import React from 'react'

import useSwr from 'swr'

import { Form } from '_zari/core'

import { TiposTablaComunConstant } from 'constants/index'

import * as TablaComunService from 'services/tablasComunes.service'

const DistritoSelect = ({ disabled, idProvincia, ...props }) => {
  const fetcher = React.useMemo(() => {
    return () =>
      TablaComunService.getAsSelect(TiposTablaComunConstant.DISTRITO, {
        _idProvincia: idProvincia
      }).then(({ data }) => data)
  }, [idProvincia])

  const { data: distritos, isValidating } = useSwr(`select_distrito_${idProvincia}`, fetcher, {
    initialData: [],
    revalidateOnMount: true,
    revalidateOnFocus: false,
    dedupingInterval: 1000 * 60 * 15
  })

  return (
    <Form.Select {...props} disabled={disabled || isValidating}>
      <option value=''>Seleccionar</option>
      {distritos.map((val, key) => (
        <option key={key} value={val._id}>
          {val.nombre}
        </option>
      ))}
    </Form.Select>
  )
}

export default React.memo(DistritoSelect)
